import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Url } from '../../models/url';
import { ConfigurationService } from '../../../entry-routes/configuration/configuration.service';
import { WkfSupervisionParams } from '../../models/workflow/wkf-supervision-params';

@Injectable({
    providedIn: 'root'
})
export class WkfSupervisionService {
    constructor(    private httpClient: HttpClient,
                    private configAction: ConfigurationService) {

    }

    getWkfSupervisionParams(currentDomain: string) : Observable<WkfSupervisionParams> {
        const httpHeaders: HttpHeaders = new HttpHeaders();
        const params = new HttpParams();//.set("_domains",currentDomain);
        return this.httpClient.get<WkfSupervisionParams>(Url.getFlowableProtectedApiBaseUrl(this.configAction)+Url.WKF_NEXIA_API+'/'+Url.SUPERVISION_PARAMS+'/'+currentDomain,{headers: httpHeaders, params: params});
    }
}